import {RichSearchList} from './search-list/rich-search-list';

export class SearchRequest{
  timestamp: number;

  phrase: string;
  page?: number;
  pageSize?: number;
  sort?: string;
  filter?: string;
  textOnly?: boolean;

  materialization?: boolean;
  ids?: string[];

  searchRespone: RichSearchList;

  constructor(attr: {phrase: string, page?: number, pageSize?: number, sort?: string, filter?: string, textOnly?: boolean, ids?: string[], materialization?: boolean}) {
    this.timestamp = Date.now();
    this.phrase = attr.phrase;
    this.page = attr.page;
    this.pageSize = attr.pageSize;
    this.sort = attr.sort;
    this.filter = attr.filter;
    this.textOnly = attr.textOnly;
    this.ids = attr.ids;
    this.materialization = attr.materialization;
  }
}
